"use strict";

(function (global) {

  global._iw = {}; // initial width
  global._jo = {}; // jObjects
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Кэширование объектов, для дальнейшего использования
  * @since 5.0.0.4200
  * @private
  * @function Core.header.actions._preInitObjects
  * @return {Core.header.actions}
  */
  global._preInitObjects = function () {
    if ($.isEmptyObject(global._jo)) {
      global._jo.header = $("#header");
      global._jo.info = $("#info");
      global._jo.actions = $("#actions");
      global._jo.caption = $("#caption_container");
    };

    if ($.isEmptyObject(global._iw)) {
      global._iw.info = global._jo.info.width();
      global._iw.actions = global._jo.actions.width();
      global._iw.caption = global._jo.caption.css("marginRight");
    };


    // Корректируем отступ заголовка для корректной работы при изменении окна браузера.
    global._jo.caption.css('margin-left', $('#logo_container').outerWidth(true));

    global._initHovers();
    return global;
  }
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Меняем спрайты при наведении мыши на иконки.
  */
  global._initHovers = function () {
    var button = global._jo.actions.find('.usermenu_button p');
    button
    .on("mouseenter.actions", function () {
      var oldImage = $(this).attr("class").replace("Hovered", "").split(".");
      $(this).attr("class", oldImage[0] + "Hovered." + oldImage[1]);
    })
    .on('mouseleave.actions', function () {
      var oldImage = $(this).attr("class").replace("Hovered", "");
      $(this).attr("class", oldImage);
    });

    $("#username").on("mouseenter.actions", function () {
      var oldImage = $(this).children("p").attr("class").replace("Hovered", "").split(".");
      $(this).children("p").attr("class", oldImage[0] + "Hovered." + oldImage[1]);
    })
    .on('mouseleave.actions', function () {
      var oldImage = $(this).children("p").attr("class").replace("Hovered", "");
      $(this).children("p").attr("class", oldImage);
    });

  };

  /**
  * Меню для кнопочки с вопросительным знаком
  * @since 5.0.0.4200
  * @function Core.header.actions.initAboutMenu   
  * @return {Core.header.actions}
  */
  global.initAboutMenu = WA.tryCatchDecorator(function () {
    var jAbout = $("#header_about_action");
    if (!jAbout.hasClass('inited')) {
      jAbout.on('click', function () {
        window.open("/Settings.aspx?view=About", 'settings');
      });
    }
    return global;
  });
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Меню для кнопочки с шестерней. (Настройки)
  * @since 5.0.0.4200
  * @function Core.header.actions.initSettingsMenu   
  * @return {Core.header.actions}
  */
  global.initSettingsMenu = WA.tryCatchDecorator(function () {
    $("#header_settings_action").on('click', function () {
      window.open("/Settings.aspx", 'settings');
    });
    return global;
  });
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Подсказка на имя текущего пользователя.
  * @since 5.0.0.4200
  * @function Core.header.actions.initCurrentUserHint 
  * @return {Core.header.actions}
  */
  global.initCurrentUserHint = function (usersRefCode, userId, hasHint) {
    $(function () {
      var jUsername = $('#username');
      jUsername.data('data-hint', { 'compcode': usersRefCode, 'id': userId });
      var position = {
        target: jUsername,
        adjust: {
          mouse: false,
          x: -120,
          y: +118
        }
      };
      InitAdditionalInfoTooltip(jUsername, position);
    });
    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

})(window.Core.header.actions);